import PropTypes from 'prop-types'
import React from 'react'
import '../../stylesheet/multipleselect.css'

class MultipleSelect extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            array: [],
            filtered: [],
            selected: false,
            value: '',
            term: this.props.default,
            allSelected: false,

        }
    }

    componentDidUpdate() {

        if (this.props.items && this.props.items !== this.state.array) {


            if (this.props.selected) {

                this.props.selected.forEach(sel => {
                    this.props.items.forEach(item => {
                        if (sel[this.props.kiey] === item[this.props.kiey]) {


                            item.selected = true
                        }





                    })
                })
            }
            this.setState({
                array: this.props.items,
                array1: this.props.items,
                filtered: this.props.items,
                value: this.props.default
            })
        }
        if (this.props.default && this.state.term === '') {
            this.setState({ term: this.props.default })
        }
    }

    toggleSelect = () => {

        this.setState({ selected: true })
    }

    closeSelect = () => {
        //if(!this.state.term){ this.setState({ term: this.props.default }) }
        this.setState({ selected: false })
    }

    selectItem = (e, item) => {
        item.selected = item.selected ? false : true

        if (this.props.multiple) {
            this.setState({ ...this.state })


            if (item.programId === "ALL") {

                let data1 = this.state.array1.filter((item => item.programId !== "ALL"))

                let data2 = this.state.array1.map((item => item.programId !== "ALL"))

                this.setState({
                    allSelected: !this.state.allSelected
                }, () => {
                    if (item.selected === true) {

                        this.setState({
                            checked: data2,
                            allSelected: true
                        })
                        this.props.setValues(data1)
                    }
                    else {



                        let data3 = this.state.array1.filter(item1 => item1.selected === true)

                        this.props.setValues(data3)
                        this.setState({
                            allSelected: false,
                            checked: item.selected
                        })

                    }
                })

            }
            else {

                // item.selected = item.selected ? false : true
                this.setState({
                    // allSelected: false,
                    checked: item.selected
                })


                let data = this.state.array.filter(item1 => item1.selected === true)


                this.state.allSelected === false &&
                    this.props.setValues(data)
            }
        } else {
            this.setState({ term: item[this.props.description] })

            this.props.selectValue({

                target: { name: this.props.name, value: item[this.props.value], term: item[this.props.description] }
            })
            this.closeSelect()
        }
    }

    renderItems = () => {


        if (this.state.selected) {
            return this.state.filtered.map(item => (

                <div
                    className={`select-item ${item[this.props.disabled]}  ${this.props.disabled}`}
                    key={item[this.props.kiey]}
                    value={item[this.props.value]}
                    onClick={e => this.selectItem(e, item)}>
                    { this.props.multiple &&
                        <label className="switch">
                            <input
                                checked={this.state.allSelected === true ? this.state.checked : item.selected}
                                type="checkbox"
                                id="required"
                                onClick={e => this.selectItem(e, item)} />
                            <span className="slider"></span>
                        </label>}
                    <span>
                        {this.props.image && <img
                            src={`${item[this.props.flag]}`}
                            alt="Flag"
                            height="20"
                            width="20"
                            className="rounded-circle ml-2 mr-2" />}
                    </span>
                    <span style={{ marginLeft: '5px' }}>
                        {item[this.props.description]}
                    </span>
                </div>
            ))
        }
    }

    selectSearch = e => {
        let term = e.target.value.toLowerCase()

        let clone = [...this.state.array]
        // eslint-disable-next-line
        let filtered = clone.filter(item => {
            let lc = item[this.props.searchKey].toLowerCase()



            if (lc.includes(term)) {

                return item
            }


        })
        this.setState({ filtered, term })

    }

    render() {



        return (
            <div className="multiple-select">
                <div className="select-field">
                    <input
                        value={this.state.term}
                        name={this.props.name}
                        term={this.state.term}
                        className="search"
                        id="input-field"
                        autocomplete="nope"
                        type="text"
                        onClick={this.toggleSelect}
                        onChange={this.selectSearch}
                        disabled={this.props.disabled === true ? true : false}
                        style={{ borderBottom: this.props.errorText && '2px solid #f44336' }}
                    />
                    <label
                        htmlFor="input-field"
                        style={{ fontSize: "11px", color: "rgb(110, 113, 121) !important", fontFamily: "Roboto, sans-serif !important" }}
                        id={this.props.required}
                        className={` simsfont multiple-select-label ${this.state.term && 'mini-label'} ${this.props.default && 'mini-label'}`}>
                        {this.props.placeholder}
                    </label>
                    <i className="fa fa-sort-down multiple-select-icon"></i>
                </div>
                <div
                    className="items-container"
                    style={{ overflowY: this.state.selected ? 'scroll' : 'hidden' }}>
                    {this.renderItems()}
                </div>
                {this.props.errorText && <div className="error-block">
                    <small style={{ color: '#f44336' }}>{this.props.errorText}</small>
                </div>}
                { this.state.selected && (
                    <div
                        className="overlay"
                        onClick={this.closeSelect} />
                )}
            </div>
        )
    }
}

MultipleSelect.propTypes = {
    items: PropTypes.array.isRequired,
    kiey: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    searchKey: PropTypes.string.isRequired,
    selected: PropTypes.array,
    multiple: PropTypes.bool,
    image: PropTypes.bool,
    setValues: PropTypes.func,
    selectValue: PropTypes.func,
    flag: PropTypes.string,
    currencyFlag: PropTypes.string,
    default: PropTypes.string,
    placeholder: PropTypes.string
}

MultipleSelect.defaultProps = {
    items: [],
    kiey: 'id',
    name: 'name',
    value: 'value',
    description: 'description',
    term: 'description',
    searchKey: 'description',
    selected: [],
    multiple: false,
    image: false,
    flag: 'flag',
    currencyFlag: false,
    default: '',
    placeholder: '',
    id: 'required'
}

export default MultipleSelect


// WEBPACK FOOTER //
// ./src/components/common/multiselect.jsx